import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import { register } from "../redux/apiCalls";
import { mobile } from "./../responsive";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background: linear-gradient(
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 0.5)
    ),
    url("https://img.freepik.com/free-photo/young-beautiful-blonde-woman-jacket-blue-wall-with-mobile-phone-doing-online-shopping_496169-1447.jpg?w=1060&t=st=1665831648~exp=1665832248~hmac=f3b8d0a506af065c0a761f0e4d46211fd398b0fec113c1bf774752890136231b")
      no-repeat center;

  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled.div`
  width: 40%;
  padding: 20px;
  background-color: white;

  ${mobile({ width: "75%" })}
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 300;
`;

const Form = styled.form`
  display: flex;
  flex-wrap: wrap;
`;

const Input = styled.input`
  flex: 1;
  min-width: 40%;
  margin: 20px 10px 0px 0px;
  padding: 10px;
`;

const Agreement = styled.span`
  font-size: 12px;
  margin: 20px 0px;
`;

const Button = styled.button`
  width: 40%;
  border: none;
  padding: 15px 20px;
  background-color: teal;
  color: white;
  cursor: pointer;
  /* text-align: center; */

  ${mobile({ width: "100%" })}
`;

const Error = styled.span`
  color: red;
  text-align: center;
  margin: 10px 0px;
`;

const Register = () => {
  const user = useSelector((state) => state.user);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [error, setError] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // console.log(user.msgUserErr);

  const handleRegister = (e) => {
    console.log("register..");
    e.preventDefault();

    if (
      username === "" ||
      password === "" ||
      confirmPw === "" ||
      email === "" ||
      password.length !== confirmPw.length
    ) {
      // console.log(typeof user.error === "boolean");
      // console.log("err");
      setError(true);
      return;
    }

    register(dispatch, { username, email, password });

    if (!error || !user.error || !user.msgUserErr) {
      // console.log(error);
      // console.log(user.error);
      // console.log("no err");
      navigate("/login");
    }
  };

  return (
    <Container>
      <Wrapper>
        <Title>CREATE AN ACCOUNT</Title>
        <Form>
          <Input placeholder="First Name" />
          <Input placeholder="Last Name" />
          <Input
            placeholder="Username"
            onChange={(e) => {
              setUsername(e.target.value);
            }}
          />
          <Input
            placeholder="Email"
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          <Input
            placeholder="Password"
            type="password"
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />
          <Input
            placeholder="Confirm Password"
            type="password"
            onChange={(e) => {
              setConfirmPw(e.target.value);
            }}
          />
          <Agreement>
            By creating an account, I consent to the processing of my personal
            data in accordance with the <b>PRIVACY POLICY</b>
          </Agreement>
          {/* {(error || user.error) && (
            <Error>Something went wrong. Please try again!</Error>
          )} */}

          <Button onClick={handleRegister}>
            {user.isFetching ? "Sending..." : "CREATE"}
          </Button>
          {user.msgUserErr ? user.msgUserErr : ""}
          {error && <Error>Something went wrong. Please try again!</Error>}
        </Form>
      </Wrapper>
    </Container>
  );
};

export default Register;
